var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvaluationsAndResolutions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2 0C54.6359 0 55.8194 1.09378 55.9812 2.50291L56 2.83333L56 65.1667C56 66.6197 54.9191 67.8173 53.5265 67.9809L53.2 68L30.8 68C29.2536 68 28 66.7315 28 65.1667C28 63.7136 29.0809 62.5161 30.4735 62.3524L30.8 62.3333L50.4 62.3333L50.4 5.66667L25.2538 5.66614L5.6 6.04633L5.6 14.1667C5.6 15.6197 4.51909 16.8173 3.12654 16.9809L2.8 17C1.36406 17 0.18058 15.9062 0.0188376 14.4971L0 14.1667L0 3.26923C0 1.83591 1.05283 0.647486 2.42434 0.461261L2.74616 0.436421L25.2 0L53.2 0Z",
    transform: "matrix(-1 0 0 1 62 5)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(17 20)",
    id: "Rectangle",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(17 39)",
    id: "Rectangle-Copy",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2 0C54.6359 0 55.8194 1.09378 55.9812 2.50291L56 2.83333L56 65.1667C56 66.6197 54.9191 67.8173 53.5265 67.9809L53.2 68L8.4 68C6.8536 68 5.6 66.7315 5.6 65.1667C5.6 63.7136 6.68091 62.5161 8.07346 62.3524L8.4 62.3333L50.4 62.3333L50.4 5.66667L25.2538 5.66614L5.6 6.04633L5.6 51C5.6 52.453 4.51909 53.6506 3.12654 53.8143L2.8 53.8333C1.36406 53.8333 0.18058 52.7396 0.0188376 51.3304L0 51L0 3.26923C0 1.83591 1.05283 0.647486 2.42434 0.461261L2.74616 0.436421L25.2 0L53.2 0Z",
    transform: "matrix(-1 0 0 -1 84 85)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(39 34)",
    id: "Rectangle",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(39 53)",
    id: "Rectangle-Copy",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(59 59)",
    id: "Path-4-Copy",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(59 39)",
    id: "Path-4-Copy-2",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(79 22)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationsAndResolutions);
export default __webpack_public_path__ + "static/media/evaluationsAndResolutions.c9efc4b0626dc97efd8332aeb91949bc.svg";
export { ForwardRef as ReactComponent };